import {
    HistoricoInterface,
    ICasoAtividade,
} from "../../../Interfaces/Geral/Historicos/HistoricoInterface";
import {
    AtualizarCasoAtividadeService,
    AtualizarHistoricoService,
    CadastrarCasoAtividadeService,
    CadastrarHistoricoService,
    DeletarCasoAtividadeService,
    DeletarHistoricoService,
    ExportarExcelGenericoService,
    ListaInformacoesVendasService,
    ListarCasoAtividadeAgendaService,
    ListarCasoAtividadeFiltroService,
    ListarCasoAtividadeService,
    ListarHistoricosService,
    ListarHistoricoUAUService,
    MarcarHistoricoLidoService,
    UpdateCasoAtividadeService,
} from "../../../Services/Geral/Historicos/HistoricosService";

import { Controller } from "../../Controller";

export async function ListarHistoricosController(idCaso: number) {
    return Controller(ListarHistoricosService(idCaso));
}

export async function ExportarExcelGenericoController(
    requestBody: {
        ID_CASO: number;
        DS_USUARIO: string;
        DS_HISTORICO: string;
        DT_CADASTRO: string;
    }[]
) {
    return Controller(ExportarExcelGenericoService(requestBody));
}

export async function ListarHistoricoUAUController(ID_CHAVE_ERP: string) {
    return Controller(ListarHistoricoUAUService(ID_CHAVE_ERP));
}

export async function CadastrarHistoricosController(
    requestBody: HistoricoInterface
) {
    return Controller(
        CadastrarHistoricoService(requestBody),
        "Histórico cadastrado com sucesso!"
    );
}

export async function MarcarHistoricoLidoController(
    idCasoHistorico: number,
    FL_LIDO: boolean
) {
    return Controller(MarcarHistoricoLidoService(idCasoHistorico, FL_LIDO));
}

export async function AtualizarHistoricosController(
    requestBody: HistoricoInterface
) {
    return Controller(
        AtualizarHistoricoService(requestBody),
        "Histórico alterado com sucesso!"
    );
}

export async function DeletarHistoricosController(ID_CASO_HISTORICO: number) {
    return Controller(
        DeletarHistoricoService(ID_CASO_HISTORICO),
        "Histórico removido com sucesso!"
    );
}

export async function ListarCasoAtividadeController(ID_CASO_ATIVIDADE: number) {
    return Controller(ListarCasoAtividadeService(ID_CASO_ATIVIDADE));
}

export async function UpdateCasoAtividadeController(
    requestBody: ICasoAtividade
) {
    return Controller(UpdateCasoAtividadeService(requestBody));
}

export async function DeletarCasoAtividadeController(
    resquestBody: Array<number>
) {
    return Controller(DeletarCasoAtividadeService(resquestBody));
}

export async function CadastrarCasoAtividadeController(
    requestBody: ICasoAtividade
) {
    return Controller(CadastrarCasoAtividadeService(requestBody));
}

export async function AtualizarCasoAtividadeController(
    requestBody: ICasoAtividade
) {
    return Controller(AtualizarCasoAtividadeService(requestBody));
}

export async function ListarCasoAtividadeAgendaController(
    DT_INICIO: string,
    DT_FIM: string
) {
    return Controller(ListarCasoAtividadeAgendaService(DT_INICIO, DT_FIM));
}

export async function ListarCasoAtividadeFiltroController(
    Filtro: string,
    DT_INICIO: string,
    DT_FIM: string
) {
    return Controller(
        ListarCasoAtividadeFiltroService(Filtro, DT_INICIO, DT_FIM)
    );
}

export async function ListaInformacoesVendasController(
    ID_EMPREENDIMENTO: number,
    DT_FIM: string,
    DT_INICIO: string
) {
    return Controller(
        ListaInformacoesVendasService(ID_EMPREENDIMENTO, DT_FIM, DT_INICIO)
    );
}
